import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton";
import Icon from "@ui/atoms/Icon/Icon";

export interface XButtonProps {
  handleClose: () => void;
  sx?: IconButtonProps["sx"];
  /** Inline style escape hatch — wins over the styled right/top defaults. */
  style?: React.CSSProperties;
  dataTestId?: string;
}

const StyledIconButton = styled(IconButton)(({ theme }) => {
  return {
    color: theme.vars.palette.icon.default,
    position: "absolute",
    right: 25,
    top: 10,
    zIndex: 1
  };
});

const XButton = ({ dataTestId, handleClose, style, sx }: XButtonProps) => {
  return (
    <StyledIconButton
      aria-label="close"
      data-test-id={dataTestId ?? "close-modal-button"}
      onClick={handleClose}
      style={style}
      sx={sx}
    >
      <Icon name="close" />
    </StyledIconButton>
  );
};

export default XButton;
